"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedLocationPlaceHolderLinkType = exports.SharedLocationPlaceHolderType = void 0;
var action_1 = require("../action");
var SharedLocationPlaceHolderType;
(function (SharedLocationPlaceHolderType) {
    SharedLocationPlaceHolderType["MERCHANT"] = "Merchant";
    SharedLocationPlaceHolderType["CUSTOMER"] = "Customer name";
    SharedLocationPlaceHolderType["USER"] = "Driver name";
    SharedLocationPlaceHolderType["JOB"] = "Job description";
    SharedLocationPlaceHolderType["TITLE"] = "Order title";
    SharedLocationPlaceHolderType["ID"] = "Order id";
    SharedLocationPlaceHolderType["WAY_POINT_CUSTOMER"] = "Way point's customer's name";
    SharedLocationPlaceHolderType["FIRST_NAME"] = "Customer's first name";
    SharedLocationPlaceHolderType["TIME_WINDOW"] = "Order's delivery time window";
    SharedLocationPlaceHolderType["ADDRESS"] = "Delivery address";
    SharedLocationPlaceHolderType["TEAM_DESCRIPTION"] = "Team description";
    SharedLocationPlaceHolderType["UUID"] = "Unique notification ID";
})(SharedLocationPlaceHolderType || (exports.SharedLocationPlaceHolderType = SharedLocationPlaceHolderType = {}));
var SharedLocationPlaceHolderLinkType;
(function (SharedLocationPlaceHolderLinkType) {
    SharedLocationPlaceHolderLinkType["SCHEDULE"] = "Schedule link";
    SharedLocationPlaceHolderLinkType["PICKUP"] = "Pickup link";
    SharedLocationPlaceHolderLinkType["SCHEDULE_READY"] = "Schedule ready link";
    SharedLocationPlaceHolderLinkType["TRACKING"] = "Tracking link";
})(SharedLocationPlaceHolderLinkType || (exports.SharedLocationPlaceHolderLinkType = SharedLocationPlaceHolderLinkType = {}));
//# sourceMappingURL=share_location_types.js.map